import { profileInitialState } from 'app/store/Profile/slice';
import { appStateMock, href } from 'app/utils/test/constants';
import { SongStatusType } from 'types/song';

export const PIN_DRAG_EVENT_TYPE = 'PIN_DRAG';

const getState = (withSongs = false) => ({
  ...appStateMock,
  auth: {
    ...appStateMock.auth,
    services: {
      ...appStateMock.auth.services,
      'releases-2': {
        _links: {
          createReleaseVersion: href,
        },
      },
    },
  },
  profile: {
    ...profileInitialState,
    currentProfileGuid: 'profileGuid',
  },
  songList: {
    ...appStateMock.songList,
    isFetchingSongs: false,
    pinned: withSongs
      ? {
          songs: [...Array(10)].map((_, index) => ({
            guid: String(index),
            title: `Title-${index}`,
            created: {
              timestamp: index,
              iso: '',
            },
            updated: {
              timestamp: index,
              iso: '',
            },
            status: [
              SongStatusType.HOLD,
              SongStatusType.IN_CREATION,
              SongStatusType.PITCHABLE,
              SongStatusType.RELEASED,
            ][Math.floor(Math.random() * 4)],
            createdBy: 'Test',
          })),
        }
      : undefined,
  },
});

export const TEST_STATES = {
  empty: getState(),
  withSongs: getState(true),
};
